var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"small-text"},[_vm._v(_vm._s(_vm.smallText))]),_c('div',{staticClass:"home-description",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.description))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }